import React from 'react';

export default function CameraStreamingIcon({ className = '' }) {
  return (
    <div
      className={`streamingGroup w-12 h-12 ${className} hover:animate-camera`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        className="w-full h-full"
      >
        {/* 카메라 본체 */}
        <path
          className="body"
          d="M27.1201 9.26733L14.3917 9.26733H8.91862L3.44556 14.7404V20.2135V31.1596H27.1201V9.26733Z"
          fill="#1581FC"
        />
        {/* 렌즈 */}
        <path
          className="lens"
          d="M36.5546 9.26721L29.053 13.5752V26.8514L36.5546 31.1595V9.26721Z"
          fill="#131313"
        />
      </svg>
    </div>
  );
}
